import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { FaFacebookF, FaLinkedinIn, FaYoutube, FaXTwitter } from 'react-icons/fa6';
import { useAuth } from '../contexts/AuthContext';
import { SubscribeModal } from './SubscribeModal';
import { SignInModal } from './SignInModal';

const navItems = [
  { label: 'Tech Lab', href: '/categories?focus=tech-lab' },
  { label: 'Business', href: '/categories?focus=business' },
  { label: 'Top Lists', href: '/categories?focus=top-lists' },
  { label: 'Living', href: '/categories?focus=living' },
  { label: 'Steals', href: '/categories?focus=steals' },
  { label: 'How Tos', href: '/categories?focus=how-tos' }
];

const socials = [
  { label: 'X', href: 'https://x.com/questflow', icon: <FaXTwitter aria-hidden="true" /> },
  { label: 'LinkedIn', href: 'https://www.linkedin.com/company/questflow', icon: <FaLinkedinIn aria-hidden="true" /> },
  { label: 'Facebook', href: 'https://www.facebook.com/questflow', icon: <FaFacebookF aria-hidden="true" /> },
  { label: 'YouTube', href: 'https://www.youtube.com/@questflow', icon: <FaYoutube aria-hidden="true" /> }
];

export function NavBar() {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { user, signOut } = useAuth();

  const handleAuthAction = async () => {
    if (user) {
      await signOut();
    }
  };

  return (
    <header className="navbar">
      <div className="site-shell nav-shell">
        <div className="navbar-top">
          <Link to="/" className="brandmark" aria-label="Questflow home">
            <img src="/logo.jpeg" alt="QuestFlow logo" width={75} height={75} className="brand-logo" />
            <div className="brandmark-text">
              <span className="brandmark-name brandmark-name--nav">
                <span className="brandmark-quest">Quest</span>
                <span className="brandmark-flow">Flow</span>
              </span>
            </div>
          </Link>
          <div className="nav-actions">
            <div className="nav-social">
              {socials.map((s) => (
                <a key={s.label} href={s.href} aria-label={s.label} className="social-link" target="_blank" rel="noopener noreferrer">
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    {s.icon}
                  </svg>
                </a>
              ))}
            </div>
            {user ? (
              <div className="nav-auth">
                <Link to="/dashboard" className="nav-cta">
                  Dashboard
                </Link>
                <button onClick={handleAuthAction} className="nav-cta nav-cta--secondary">
                  Sign Out
                </button>
              </div>
            ) : (
              <>
                <SubscribeModal triggerLabel="Subscribe" triggerClassName="nav-cta" />
                <SignInModal triggerLabel="Sign In" triggerClassName="nav-cta nav-cta--secondary" />
              </>
            )}
          </div>
        </div>

        <div className="navbar-bottom">
          <nav className="nav-links" aria-label="Primary">
            {navItems.map((item) => {
              const target = new URL(item.href, window.location.origin);
              const targetPath = target.pathname;
              const targetFocus = target.searchParams.get('focus');
              const currentFocus = searchParams.get('focus');

              const isActive =
                item.href === '/'
                  ? location.pathname === '/'
                  : targetFocus
                    ? location.pathname.startsWith(targetPath) && currentFocus === targetFocus
                    : location.pathname === targetPath;

              return (
                <Link key={item.label} to={item.href} className={`nav-link ${isActive ? 'active' : ''}`}>
                  {item.label}
                </Link>
              );
            })}
          </nav>
        </div>
      </div>
    </header>
  );
}
